import useSettingsFunctionTypeEditRoute_AddObservationType from "../api/useSettingsFunctionTypeEditRoute_AddObservationType";
import useSettingsFunctionTypeEditRoute_Delete from "../api/useSettingsFunctionTypeEditRoute_Delete";
import useSettingsFunctionTypeEditRoute_GetById from "../api/useSettingsFunctionTypeEditRoute_GetById";
import useSettingsFunctionTypeEditRoute_RemoveObservationType from "../api/useSettingsFunctionTypeEditRoute_RemoveObservationType";
import useSettingsFunctionTypeEditRoute_Update from "../api/useSettingsFunctionTypeEditRoute_Update";

export function useSettingsFunctionTypeData(functionTypeId: string) {
    const queryData = useSettingsFunctionTypeEditRoute_GetById(functionTypeId);
    const updateMutation = useSettingsFunctionTypeEditRoute_Update();
    const deleteMutation = useSettingsFunctionTypeEditRoute_Delete();

    const addObservationTypeMutation = useSettingsFunctionTypeEditRoute_AddObservationType();
    const removeObservationTypeMutation = useSettingsFunctionTypeEditRoute_RemoveObservationType();

    return {
        queryData,
        updateMutation,
        deleteMutation,
        addObservationTypeMutation,
        removeObservationTypeMutation,
    };
}
